// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"PageNotFound_pageWrapper__3472n"};